import { ReactNode } from 'react';

import { SingleMessageAvatar } from '@domains/new-conversation/atoms/SingleMessageAvatar/SingleMessageAvatar';

import { Container, Message, MessageWrapper } from './SingleMessage.styled';

interface SingleMessageProps {
    children?: ReactNode;
    isUserMessage?: boolean;
    onClick?: () => void;
    showAvatar?: boolean;
}

export const SingleMessage = ({
    children,
    isUserMessage,
    onClick,
    showAvatar = true,
}: SingleMessageProps) => {
    const avatarShown = !isUserMessage && showAvatar;

    return (
        <Container isUserMessage={isUserMessage} onClick={onClick}>
            {avatarShown && <SingleMessageAvatar />}
            <MessageWrapper
                avatarShown={!avatarShown}
                className="htmlToImageIgnore"
                isUserMessage={isUserMessage}
            >
                <Message isUserMessage={isUserMessage}>{children}</Message>
            </MessageWrapper>
        </Container>
    );
};
